import { render, staticRenderFns } from "./drawPart.vue?vue&type=template&id=4c8b95cf&scoped=true&"
import script from "./drawPart.vue?vue&type=script&lang=js&"
export * from "./drawPart.vue?vue&type=script&lang=js&"
import style0 from "./drawPart.vue?vue&type=style&index=0&id=4c8b95cf&prod&scoped=true&lang=less&"
import style1 from "./drawPart.vue?vue&type=style&index=1&id=4c8b95cf&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b95cf",
  null
  
)

export default component.exports